export default "__VITE_ASSET__dfe1b30f__"